import { render } from "./404NotFound.vue?vue&type=template&id=1ce91454"
import script from "./404NotFound.vue?vue&type=script&lang=js"
export * from "./404NotFound.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nceba/Documents/code/apps/twist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__